import React from 'react';
import PropTypes from 'prop-types';
import {Paper, Subheader} from "material-ui";
import {connect} from "react-redux";
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import {postApp} from '../../../store/apps/actions';
import ApplicationForm from "../../../components/application/ApplicationForm/ApplicationForm";
import style from '../../../styles/styles';
import styles from './AddApplicationPage.css';
import withTranslation from "../../../hoc/withTranslation";
import {APPLICATION_PAGE} from "../../../constants/routes";

export class AddApplicationPage extends React.Component {
    static propTypes = {
        app: PropTypes.object
    };

    static defaultProps = {
        loading: true,
        app: null,
        submitting: false
    };

    componentWillUpdate(nextProps) {
        if (nextProps.app && !nextProps.submitting) {
            this.props.history.push(APPLICATION_PAGE.replace(':appId', nextProps.app.id));
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
       await this.props.postApp(formProps);
    };

    // Render

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading) {
            return <Loading paper={false}/>;
        }

        return (
            <div>
                <h3 style={style.navigation}>{this.props.t('generic.application')} / {this.props.t('generic.add')}</h3>
                <Paper style={styles.editBox}>
                    <Subheader style={style.subHeader}>{this.props.t('account_page.new_app')}</Subheader>
                    <div style={style.paper}>
                        <ApplicationForm
                            onSubmit={this.handleFormSubmit}
                            submitting={this.props.submitting}
                        />
                    </div>
                    <div style={style.clear}/>
                </Paper>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.sending,
        error: state.apps.error,
        submitting: state.apps.sending
    };

    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
    }

    return props;
}

export default connect(mapStateToProps, {
    postApp
})(withTranslation(AddApplicationPage));



// WEBPACK FOOTER //
// src/containers/application/AddApplicationPage/AddApplicationPage.js